import { Context, createContext, Dispatch, SetStateAction } from 'react';

import { useRequiredContext } from '@/hooks';

import { JoystickConfigMap } from './gamepad.types';

export type GamepadContextValue = {
  /** is a gamepad currently connected */
  isGamepadConnected: boolean;

  gamepadId: string;
  /** define / update global mappings (navigation etc.) */
  setGlobalMap: (map: JoystickConfigMap) => void;
  /** clear global override and return to provider default mappings */
  clearGlobalMap: () => void;

  /** register bindings for a widget; replaces previous bindings for this widgetId */
  registerWidgetMap: (widgetId: string, map: JoystickConfigMap) => void;

  /** remove widget map (e.g. on unmount) */
  unregisterWidgetMap: (widgetId: string) => void;

  /** which widget is currently “active/selected” for widget-specific actions */
  activeWidgetId: string | null;
  setActiveWidgetId: Dispatch<SetStateAction<string | null>>;
};

export const GamepadContext: Context<GamepadContextValue | undefined> = createContext<
  GamepadContextValue | undefined
>(undefined);

export const useGamepadContext = (): GamepadContextValue =>
  useRequiredContext({
    context: GamepadContext,
    hookName: 'useGamepadContext',
    providerName: 'GamepadProvider',
  });
